import { create } from 'zustand'
import useQueryGetMe from '@/api/auth/getMe.ts'

const DEFAULT_ON_EMAILS = ['ktt@carearly.com']

const storageKey = (accountId: number) => `alarm_sound_enabled:${accountId}`

interface IAlarmSoundAccount {
    id: number
    email: string
}

/** 이 브라우저에 계정별로 저장한 값, 없으면 DEFAULT_ON_EMAILS 계정만 켬 */
export const readAlarmSound = (account: IAlarmSoundAccount) => {
    try {
        const saved = localStorage.getItem(storageKey(account.id))
        if (saved !== null) return saved === '1'
    } catch {
        // 저장소를 못 읽으면 기본값으로 정한다
    }
    return DEFAULT_ON_EMAILS.includes(account.email)
}

const saveAlarmSound = (accountId: number, enabled: boolean) => {
    try {
        localStorage.setItem(storageKey(accountId), enabled ? '1' : '0')
    } catch {
        // 저장이 막혀도 지금 화면에는 적용한다
    }
}

interface IAlarmSoundStore {
    /** 이번 화면에서 바꾼 값 (계정 id → 켬) */
    changed: Record<number, boolean>
    setEnabled: (accountId: number, enabled: boolean) => void
}

export const useAlarmSoundStore = create<IAlarmSoundStore>()((set) => ({
    changed: {},
    setEnabled: (accountId, enabled) => {
        saveAlarmSound(accountId, enabled)
        set((state) => ({ changed: { ...state.changed, [accountId]: enabled } }))
    }
}))

/** 로그인한 계정의 긴급 알림음 켬/끔 */
export const useAlarmSound = () => {
    const { data: me } = useQueryGetMe()
    const changed = useAlarmSoundStore((state) => (me ? state.changed[me.id] : undefined))
    const setEnabled = useAlarmSoundStore((state) => state.setEnabled)

    return {
        enabled: !!me && (changed ?? readAlarmSound(me)),
        setEnabled: (enabled: boolean) => {
            if (me) setEnabled(me.id, enabled)
        }
    }
}
